import React from 'react';
import { FadeIn, Button, CountdownTimer } from './Shared';
import { Lock, Zap, ShieldCheck, CreditCard } from 'lucide-react';
export const FinalCTA = () => {
  const trackCheckout = (planName: string, price: number) => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout', {
        content_name: planName,
        value: price,
        currency: 'ARS'
      });
    }
  };
  return <section className="py-20 md:py-32 px-4 bg-navy-950 relative overflow-hidden" data-id="element-84">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(236,72,153,0.05),transparent_70%)] pointer-events-none" data-id="element-85"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-navy-950 via-transparent to-transparent" data-id="element-86"></div>

      <div className="max-w-5xl mx-auto relative z-10 text-center" data-id="element-87">
        <FadeIn data-id="element-88">
          <h2 className="text-[10px] md:text-xs font-black tracking-[0.2em] text-pink-500 uppercase mb-8 bg-pink-500/10 inline-block px-4 py-2 rounded-full border border-pink-500/20" data-id="element-89">
            ⏰ EL PRECIO CIERRA EN:
          </h2>
          <div className="mb-16" data-id="element-90">
            <CountdownTimer data-id="element-91" />
          </div>

          <div className="space-y-6 max-w-3xl mx-auto mb-16" data-id="element-92">
            <div className="bg-navy-900/40 p-6 md:p-10 rounded-[2rem] border border-white/5 hover:border-white/10 transition-all duration-300 backdrop-blur-sm group" data-id="element-93">
              <div className="flex flex-col md:flex-row items-center justify-between gap-6 md:gap-8" data-id="element-94">
                <div className="text-center md:text-left w-full md:w-auto" data-id="element-95">
                  <h4 className="text-xl md:text-2xl text-white mb-2 group-hover:text-pink-400 transition-colors font-[900] font-[Montserrat,_sans-serif]" data-id="element-96">
                    📘 MÉTODO CAJA ORDENADA
                  </h4>
                  <p className="text-sm text-gray-400 mb-4 font-sans tracking-wide uppercase font-bold" data-id="element-97">
                    5 Tomos + 4 Bonos
                  </p>
                  <div className="flex items-baseline justify-center md:justify-start gap-3" data-id="element-98">
                    <span className="text-gray-500 line-through text-sm font-bold" data-id="element-99">
                      $69.000
                    </span>
                    <span className="text-3xl md:text-4xl font-black text-white" data-id="element-100">
                      $19.990 <span className="text-sm text-gray-500" data-id="element-101">ARS</span>
                    </span>
                  </div>
                </div>
                <Button href="https://mundopractico.online/cart/48731797422297:1" className="w-full md:w-auto text-base px-8 py-5" onClick={() => trackCheckout('MÉTODO CAJA ORDENADA', 19990)} data-id="element-102">
                  QUIERO MI MÉTODO
                </Button>
              </div>
            </div>

            <div className="bg-navy-900/80 p-6 md:p-10 rounded-[2rem] border-2 border-pink-500/80 shadow-[0_10px_40px_rgba(236,72,153,0.15)] relative overflow-hidden group" data-id="element-103">
              <div className="absolute top-0 right-0 -mt-12 -mr-12 w-48 h-48 bg-pink-500/10 rounded-full blur-3xl group-hover:bg-pink-500/20 transition-colors" data-id="element-104" />
              <div className="flex flex-col md:flex-row items-center justify-between gap-6 md:gap-8 relative z-10" data-id="element-105">
                <div className="text-center md:text-left w-full md:w-auto" data-id="element-106">
                  <div className="inline-block bg-pink-500/20 text-pink-400 px-3 py-1 rounded-full text-[9px] font-black tracking-widest mb-3 border border-pink-500/30 uppercase" data-id="element-107">
                    ⭐ EL MÁS ELEGIDO
                  </div>
                  <h4 className="text-xl md:text-2xl text-pink-400 mb-2 transition-colors font-[900] font-[Montserrat,_sans-serif]" data-id="element-108">
                    🏆 MÉTODO + KIT VENTA RELÁMPAGO
                  </h4>
                  <p className="text-sm text-gray-300 mb-4 font-sans tracking-wide uppercase font-bold" data-id="element-109">
                    5 Tomos + 4 Bonos + Campañas Express para Convertir Stock en
                    Caja
                  </p>
                  <div className="flex items-baseline justify-center md:justify-start gap-3" data-id="element-110">
                    <span className="text-gray-400 line-through text-sm font-bold opacity-60" data-id="element-111">
                      $89.000
                    </span>
                    <span className="text-3xl md:text-4xl font-black text-white drop-shadow-[0_0_15px_rgba(236,72,153,0.2)]" data-id="element-112">
                      $27.990 <span className="text-sm text-pink-400" data-id="element-113">ARS</span>
                    </span>
                  </div>
                </div>
                <Button href="https://mundopractico.online/cart/48731815968985:1" className="w-full md:w-auto text-base px-8 py-5" onClick={() => trackCheckout('MÉTODO CAJA ORDENADA + KIT VENTA RELÁMPAGO', 27990)} data-id="element-114">
                  QUIERO EL MÉTODO + KIT VENTA RELÁMPAGO
                </Button>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-4 md:gap-10 text-[9px] md:text-[10px] font-black text-gray-400 uppercase tracking-[0.2em]" data-id="element-115">
            {[{
            icon: Lock,
            text: 'Pago 100% seguro',
            color: 'text-green-400'
          }, {
            icon: Zap,
            text: 'Acceso en 5 minutos',
            color: 'text-yellow-400'
          }, {
            icon: ShieldCheck,
            text: 'Garantía 7 días',
            color: 'text-blue-400'
          }, {
            icon: CreditCard,
            text: 'Mercado Pago | Tarjeta',
            color: 'text-purple-400'
          }].map((item, i) => <div key={i} className="flex items-center group" data-id="element-116">
                <item.icon className={`w-4 h-4 mr-3 ${item.color} drop-shadow-[0_0_8px_rgba(0,0,0,0.5)] group-hover:scale-110 transition-transform`} data-id="element-117" />
                <span className="group-hover:text-white transition-colors" data-id="element-118">
                  {item.text}
                </span>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
};